import {
  AccessTime,
  Person,
  Assignment,
  Timelapse,
  Gavel,
} from '@mui/icons-material';

import { formatDate, formatDuration, formatLongDate } from '../../../shared';
import { type OralArgumentResult } from '../../../types';

import {
  HeaderCard,
  HeaderTopSection,
  TitleRow,
  TitleContainer,
  OpinionTitle,
  CourtNameLink,
  DetailsGrid,
  DetailPill,
  DetailPillContent,
  DetailIconContainer,
  DetailLabel,
  DetailValue,
  LastUpdatedContainer,
  LastUpdatedIcon,
  LastUpdatedText,
} from './components';

interface OralArgumentDetailsHeaderProps {
  oralArgument: OralArgumentResult;
}

export const OralArgumentDetailsHeader = ({
  oralArgument,
}: OralArgumentDetailsHeaderProps) => {
  const {
    caseName,
    court,
    dateArgued,
    duration,
    docketNumber,
    docket_id,
    judges,
    judge,
    meta,
  } = oralArgument;

  const judgesDisplay = judges || judge;
  const lastUpdated =
    meta?.date_created || meta?.timestamp || dateArgued || undefined;

  return (
    <HeaderCard>
      <HeaderTopSection>
        <TitleRow>
          <TitleContainer>
            <OpinionTitle>{caseName || 'Unknown Case'}</OpinionTitle>
          </TitleContainer>
          <LastUpdatedContainer>
            <LastUpdatedIcon>
              <AccessTime />
            </LastUpdatedIcon>
            <LastUpdatedText>
              Last Updated: {formatLongDate(lastUpdated)}
            </LastUpdatedText>
          </LastUpdatedContainer>
        </TitleRow>
        {court && (
          <CourtNameLink sx={{ cursor: 'default' }}>{court}</CourtNameLink>
        )}
      </HeaderTopSection>

      <DetailsGrid>
        {court && (
          <DetailPill>
            <DetailPillContent>
              <DetailIconContainer>
                <Gavel />
              </DetailIconContainer>
              <DetailLabel>Court:</DetailLabel>
            </DetailPillContent>
            <DetailValue>{court}</DetailValue>
          </DetailPill>
        )}

        {duration != null && duration > 0 && (
          <DetailPill>
            <DetailPillContent>
              <DetailIconContainer>
                <Timelapse />
              </DetailIconContainer>
              <DetailLabel>Duration:</DetailLabel>
            </DetailPillContent>
            <DetailValue>{formatDuration(duration)}</DetailValue>
          </DetailPill>
        )}

        {docket_id != null && docket_id > 0 && (
          <DetailPill>
            <DetailPillContent>
              <DetailIconContainer>
                <Assignment />
              </DetailIconContainer>
              <DetailLabel>Docket ID:</DetailLabel>
            </DetailPillContent>
            <DetailValue>{docket_id}</DetailValue>
          </DetailPill>
        )}

        {dateArgued && (
          <DetailPill>
            <DetailPillContent>
              <DetailIconContainer>
                <AccessTime />
              </DetailIconContainer>
              <DetailLabel>Argued Date:</DetailLabel>
            </DetailPillContent>
            <DetailValue>{formatDate(dateArgued)}</DetailValue>
          </DetailPill>
        )}

        {docketNumber && (
          <DetailPill>
            <DetailPillContent>
              <DetailIconContainer>
                <Assignment />
              </DetailIconContainer>
              <DetailLabel>Docket Number:</DetailLabel>
            </DetailPillContent>
            <DetailValue>{docketNumber}</DetailValue>
          </DetailPill>
        )}

        {judgesDisplay && (
          <DetailPill>
            <DetailPillContent>
              <DetailIconContainer>
                <Person />
              </DetailIconContainer>
              <DetailLabel>Judge{judges ? 's' : ''}:</DetailLabel>
            </DetailPillContent>
            <DetailValue>{judgesDisplay}</DetailValue>
          </DetailPill>
        )}
      </DetailsGrid>
    </HeaderCard>
  );
};
